import { message } from 'antd';
import debounce from 'lodash.debounce';
import React, { type FC, type ReactElement, useEffect } from 'react';
import { Navigate } from 'react-router';

import { useAuth } from '~/hooks/useAuth';

import type { RoleSlug } from '~/types/models';

interface IRequireAuthProps {
  children: React.ReactElement;
  roles?: RoleSlug[];
  redirectTo?: string;
}

const notify = debounce(
  () => message.error("Vous n'avez pas les permissions requises pour accéder à cette page.", 10),
  100,
);

const RequireAuth: FC<IRequireAuthProps> = function ({ children, roles, redirectTo }): ReactElement {
  const { user, hasAnyRole } = useAuth();

  useEffect(() => {
    if (user && Array.isArray(roles) && !hasAnyRole(roles)) {
      notify();
    }
  }, [user]);

  if (!user) {
    return <Navigate to={redirectTo ?? '/'} replace />;
  }

  if (Array.isArray(roles) && !hasAnyRole(roles)) {
    notify();
    return <Navigate to={redirectTo ?? '/'} replace />;
  }

  return children;
};

export default RequireAuth;
